import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';
import Alert from 'react-s-alert';

import ManageDataBaseModal from './ManageDataBaseModal';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { renderTextField } from '../../../../../components/reduxFields';
import Sorting from '../../../../../components/SortingCustom';
import { resetFiltersAndSorting } from '../../../../../actions/utilAction';
import { getOrganizationDatabaseDetail, deleteDatabase } from '../actions/ManageDataBaseAction';

class ManageDataBase extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            database_Data: null,
            database_Id: null,
        }

        this.filter = {
            sort_Column: 'databaseDetailID',
            sort_Order: 'desc',
            searchText: '',
        };

        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleResetButton = this.handleResetButton.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
    }

    componentWillMount = () => {
        this.loadData()
    };

    componentWillUnmount() {
        Alert.closeAll();
    };

    handleOpen = () => {
        this.setState({ open: true, database_Data: null, database_Id: null });
    };

    handleClose = () => {
        this.setState({ open: false });
        this.props.dispatch(reset('ManageDataBaseForm'));
        this.filter.searchText = '';
    };

    handleSearchChange = (event) => {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    };

    handleResetButton = () => {
        this.props.dispatch(reset('ManageDataBaseForm'));
        resetFiltersAndSorting(this.filter, 'id', false);
        this.loadData();
    };

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_Order = col_order;
            this.loadData();
        };
    };

    handleDeleteClick(event, obj) {
        Alert.warning('Once you click yes, database details linked with this user will get effected. Are you sure you want to delete this database ?', {
            position: 'bottom-right',
            effect: 'slide',
            timeout: 10000,
            customFields: {
                displayComponent: true,
                handleButtonClick: this.handleAlertClick,
                id: obj.databaseDetailID
            },
        });
    };

    handleEditClick = (event, obj) => {
        this.setState({ open: true, database_Data: obj, databaseName: obj.databaseDetailID });
    };

    handleAlertClick = (event, databaseId) => {
        this.props.deleteDatabase(databaseId);
        Alert.closeAll();
    };

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'databaseDetailID',
            sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
            filters: { databaseName: this.filter.searchText ? this.filter.searchText : undefined },            
            pageSize: 50,
            pageNumber: page_number ? page_number : 1,
        };
        this.props.getOrganizationDatabaseDetail(searchObj);
    };

    renderData = () => {
        let orgArray = this.props.organizationDatabaseDetail.data || [];
        return orgArray.map((obj, index) => {
            return (
                <tr key={index}>
                    <td>{obj.databaseName}</td>
                    <td>{obj.serverName}</td>
                    <td>{obj.userName}</td>
                    <td>{obj.noOfOrg}</td>
                    <td className={obj.isCentralised === true ? 'greenfont' : 'redfont'}>{obj.isCentralised ? 'Yes' : 'No'}&nbsp;{/* <i className="fa fa-info-circle infoIcon"></i> */}</td>
                    <td>
                        <button onClick={(e) => this.handleEditClick(e, obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                        {/* <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button> */}
                    </td>
                </tr>
            )
        });
    }; 

    renderDbList() {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });

       // console.log("coming data-----", this.props.organizationDatabaseDetail.data)
        if (!this.props.organizationDatabaseDetail.data) {

            return (
                <table className={tableClass}>
                    <thead>
                        <tr>
                            <th width="17%"><span>DataBase Name</span></th>
                            <th width="17%"><span>Server Name</span></th>
                            <th width="17%"><span>User Name</span></th>
                            <th width="15%"><span>Assigned Count</span></th>
                            <th width="18%"><span>Centralized</span></th>
                            <th width="16%">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="7">
                                <div className="familydl text-center no-record">No record found.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        }
        // console.log(this.props.organizationDatabaseDetail)
        if (this.props.organizationDatabaseDetail.data) {
            return (
                <div>
                    <table className={tableClass}>
                        <thead>
                            <tr>
                                <th width="17%"><Sorting setSortColumn={this.setSortColumn} columnName='databaseName' displayName='DataBase Name' /></th>
                                <th width="17%"><Sorting setSortColumn={this.setSortColumn} columnName='serverName' displayName='Server Name' /></th>
                                <th width="17%"><Sorting setSortColumn={this.setSortColumn} columnName='userName' displayName='User Name' /></th>
                                <th width="15%"><Sorting setSortColumn={this.setSortColumn} columnName='noOfOrg' displayName='Assigned Count' /></th>
                                <th width="18%"><Sorting setSortColumn={this.setSortColumn} columnName='isCentralised' displayName='Centralized' /></th>
                                <th width="18%">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderData()}
                        </tbody>
                    </table>
                    <PaginatorCustom data={this.props.organizationDatabaseDetail.meta} handlePageChange={(page_number) => this.loadData(page_number)} />
                </div>
            );
        }
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <h2 className="page_title">Manage Data Base</h2>
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <div className="modalwindow">
                            <div className="row">
                                <div className="col-sm-5">
                                    <RaisedButton label="Add DataBase" primary={true} onTouchTap={this.handleOpen} />
                                </div>
                                <div className="col-sm-7">
                                    <div className="row end-flex">
                                        <div className="col-sm-6 mtm-27">
                                            <form className="readmin-form custom_form" onSubmit={handleSubmit(() => this.handleManageDataBase())}>
                                                <Field
                                                    name="Manage DataBase"
                                                    floatingLabelText="Search"
                                                    maxLength='50'
                                                    onChange={this.handleSearchChange}
                                                    component={renderTextField}
                                                />
                                            </form>
                                        </div>
                                        <div className="reset-btn col-sm-3 btn_rt">
                                            <RaisedButton onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.open ? <ManageDataBaseModal database_Data={this.state.database_Data} database_Id={this.state.database_Id} closeDialog={this.handleClose} /> : null}
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive mt-15">
                                    {this.renderDbList()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ManageDataBase = reduxForm({
    form: 'ManageDataBaseForm',
})(ManageDataBase);

function mapStateToProps(state) {
    return {
        organizationDatabaseDetail: state.manageDatabase.organizationDatabaseDetail,
        savedOrganizationData: state.manageDatabase.savedOrganizationData,
        deletedOrganisationData: state.manageDatabase.deletedOrganisationData,
    }
}

export default connect(mapStateToProps, { getOrganizationDatabaseDetail, deleteDatabase })(ManageDataBase);


// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/ManageDataBase/components/index.js